<template>
  <div class="loading">
    <img width="24" height="24" src="~common/image/loading.gif">
    <p class="desc">{{title}}</p>
  </div>
</template>
<script>
  export default {
    props: {
      title: {
        type: String,
        default: '正在载入...'
      }
    }
  }
</script>
<style lang="stylus" scoped>
  .loading
    width: 100%
    text-align: center
    .desc
      line-height: 20px
      font-size: $font-size-small
      color: $color-text-l
</style>



// WEBPACK FOOTER //
// m-loading.vue?48ebfc1c